import { render } from "./ArticleCategorySet.vue?vue&type=template&id=ea3b940e&scoped=true&ts=true"
import script from "./ArticleCategorySet.vue?vue&type=script&lang=ts"
export * from "./ArticleCategorySet.vue?vue&type=script&lang=ts"

import "./ArticleCategorySet.vue?vue&type=style&index=0&id=ea3b940e&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3b940e"]])

export default __exports__